import React, { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import socket from '../commonFunctions/socket';
import { getLocalValue, LoacalVariables } from '../commonFunctions/CommonFunctions';

type Notification = {
    message: string;
    data?: any;
    timestamp: number;
    type: string;
};

interface NotificationContextType {
    notifications: Notification[];
    clearNotifications: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);

    useEffect(() => {
        // Join user's role room if needed
        socket.emit("join", getLocalValue(LoacalVariables.UserType));

        socket.on("new-user", (data) => {
            toast.success(data.message);
            setNotifications((prev) => [{ ...data, timestamp: Date.now() }, ...prev]);
        });

        // socket.on("user-active", (data) => {
        //     toast.success(data.message);
        //     setNotifications((prev) => [{ ...data, timestamp: Date.now() }, ...prev]);
        // });

        // socket.on("user-deactive", (data) => {
        //     toast.error(data.message);
        //     setNotifications((prev) => [{ ...data, timestamp: Date.now() }, ...prev]);
        // });

        socket.on("new-loan", (data) => {
            toast.success(data.message);
            setNotifications((prev) => [{ ...data, timestamp: Date.now() }, ...prev]);
        });

        // socket.on("loan-status-updated", (data) => {
        //     toast.success(data.message);
        //     setNotifications((prev) => [{ ...data, timestamp: Date.now() }, ...prev]);
        // });

        return () => {
            socket.disconnect();
        };
    }, []);

    const clearNotifications = () => setNotifications([]);

    return (
        <NotificationContext.Provider value={{ notifications, clearNotifications }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) throw new Error("useNotifications must be used within NotificationProvider");
    return context;
};
